import { render, staticRenderFns } from "./referral-reward.vue?vue&type=template&id=7a742012&scoped=true&"
import script from "./referral-reward.vue?vue&type=script&lang=js&"
export * from "./referral-reward.vue?vue&type=script&lang=js&"
import style0 from "./referral-reward.vue?vue&type=style&index=0&id=7a742012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a742012",
  null
  
)

export default component.exports